export default "__VITE_ASSET__69fe1617__"